import { LucideIcon } from 'lucide-react';

import {
  Clock,
  Check,
  Shield,
  Mail,
  Eye,
  TrendingUp,
  TrendingDown,
  Database,
  Users,
  Zap,
  FileText,
  ArrowUp,
  MapPin,
  Phone,
  Globe,
  Package,
  Truck,
  BarChart,
  Settings,
  Cpu,
  Wifi,
  Lock,
  Key,
  CreditCard,
  DollarSign,
  Target,
  Award,
  Star,
  AlertCircle,
  Info,
  CheckCircle,
  XCircle,
  Activity,
  BarChart2,
  Bell,
  Calendar,
  Camera,
  ChevronRight,
  ChevronLeft,
  Circle,
  Copy,
  Download,
  Edit,
  EyeOff,
  Upload,
  Globe2,
  Grid,
  Heart,
  Image,
  Inbox,
  Link,
  Link2,
  List,
  Loader,
  LogIn,
  LogOut,
  Map,
  Maximize,
  Minimize,
  RefreshCw,
  Search,
  Send,
  Share,
  Share2,
  Shuffle,
  Slash,
  Smile,
  Smartphone,
  Sun,
  Tablet,
  Tag,
  Timer,
  Trash,
  Unlock,
  User,
  UserCheck,
  UserX,
  MessageCircle,
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  'clock': Clock,
  'check': Check,
  'shield': Shield,
  'mail': Mail,
  'eye': Eye,
  'trending-up': TrendingUp,
  'trending-down': TrendingDown,
  'database': Database,
  'users': Users,
  'zap': Zap,
  'file-text': FileText,
  'arrow-up': ArrowUp,
  'map-pin': MapPin,
  'phone': Phone,
  'globe': Globe,
  'package': Package,
  'truck': Truck,
  'bar-chart': BarChart,
  'settings': Settings,
  'cpu': Cpu,
  'wifi': Wifi,
  'lock': Lock,
  'key': Key,
  'credit-card': CreditCard,
  'dollar-sign': DollarSign,
  'target': Target,
  'award': Award,
  'star': Star,
  'alert-circle': AlertCircle,
  'info': Info,
  'check-circle': CheckCircle,
  'x-circle': XCircle,
  'activity': Activity,
  'bar-chart-2': BarChart2,
  'bell': Bell,
  'calendar': Calendar,
  'camera': Camera,
  'chevron-right': ChevronRight,
  'chevron-left': ChevronLeft,
  'circle': Circle,
  'copy': Copy,
  'download': Download,
  'edit': Edit,
  'eye-off': EyeOff,
  'upload': Upload,
  'globe-2': Globe2,
  'grid': Grid,
  'heart': Heart,
  'image': Image,
  'inbox': Inbox,
  'link': Link,
  'link-2': Link2,
  'list': List,
  'loader': Loader,
  'log-in': LogIn,
  'log-out': LogOut,
  'map': Map,
  'maximize': Maximize,
  'minimize': Minimize,
  'refresh': RefreshCw,
  'search': Search,
  'send': Send,
  'share': Share,
  'share-2': Share2,
  'shuffle': Shuffle,
  'slash': Slash,
  'smile': Smile,
  'smartphone': Smartphone,
  'sun': Sun,
  'tablet': Tablet,
  'tag': Tag,
  'timer': Timer,
  'trash': Trash,
  'unlock': Unlock,
  'user': User,
  'user-check': UserCheck,
  'user-x': UserX,
  'message-circle': MessageCircle,
};

export function getIcon(iconName: string): LucideIcon {
  const icon = iconMap[iconName.toLowerCase()];
  if (!icon) {
    console.warn(`Icon "${iconName}" not found, defaulting to Check icon`);
    return Check;
  }
  return icon;
}